// SharePromos logo — coupon tag with a share arrow through it
export function Logo({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="SharePromos logo"
    >
      {/* Slate background */}
      <rect width="40" height="40" rx="8" fill="#020617" />
      {/* Coupon tag outline (rotated slightly) */}
      <path
        d="M11 14 L23 10 L30 15 L28 26 L16 30 L9 25 Z"
        stroke="#10B981"
        strokeWidth="2.2"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Perforation dot on the tag */}
      <circle cx="27" cy="16" r="1.6" fill="#10B981" />
      {/* Share arrow through the tag */}
      <path
        d="M14 21 L24 21 M24 21 L21 18 M24 21 L21 24"
        stroke="#F59E0B"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Compact icon-only mark (for favicons or tight UI)
export function LogoMark({ size = 32, className = "" }) {
  return <Logo size={size} className={className} />;
}

export default Logo;
